module.exports = __webpack_public_path__ + "img/Weapon_33.9aed0371.png";